import script from "./CookieInformation.vue?vue&type=script&setup=true&lang=ts"
export * from "./CookieInformation.vue?vue&type=script&setup=true&lang=ts"

import "./CookieInformation.vue?vue&type=style&index=0&id=ec00dfac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ec00dfac"]])

export default __exports__